import PlantAnalyserScreen from '../shared/PlantAnalyserScreen';

export default function DiscomPlantAnalyser() {
  return <PlantAnalyserScreen role="discom" />;
}
